import { environment as commonEnvironment } from './environment.common.prod';

export const environment = {
    ...commonEnvironment,

    project_name: 'box8',
    brand: {
        id: 1,
        name: 'Box8',
        url: 'https://box8.in'
    },
    ymBotId: 'x1668420084925',

    googleMapKey: 'AIzaSyDf8wMsU4wEq2HgtlYfgRrRUEpKq_T_XIU',
    googleClientId: '1018270888056-pcuhb065hv6la3851vh5s7blred5qt1h.apps.googleusercontent.com',
    gtmKey: 'GTM-5RNJK7X',
    fbAnalyticsKey: '752485578225034',
    recaptchaSiteKey: '6LeqtMsUAAAAABk2CkYu5C6VrzzshU5y4_-5aC_X',

    firebaseConfig: {
        apiKey: 'AIzaSyD_hF5BOy5qnfoJms0MgLfP9tGVme75Fxw',
        authDomain: 'box8-952.firebaseapp.com',
        databaseURL: 'https://box8-dbtrack.firebaseio.com',
        storageBucket: 'box8-952.appspot.com',
        messagingSenderId: '1018270888056',
        projectId: 'box8-952',
        appId: '1:1018270888056:web:f860cb94b6b540e3983d8d',
        measurementId: 'G-Z54R37E5B4'
    },

    payments: {
        ...commonEnvironment.payments,
        amazonClientId: 'amzn1.application-oa2-client.9c09baee8869420d9929df7a52518483',
        amazonPayRediretcUri: 'box8.in',
        paytmMID: 'Poncho95408828954280'
    },

    firebaseCredentials: {
        username: '',
        password: ''
    },

    links: {
        store: {
            google: 'https://play.google.com/store/apps/details?id=com.poncho&hl=en',
            apple: 'https://apps.apple.com/in/app/box8/id631911394',
            deepLink: 'https://box8.sng.link/Ds1qo/1egv'
        },
        share: {
            fb: {
                url: 'https://www.facebook.com/Box8.in',
                handle: 'Box8.in'
            },
            twitter: {
                url: 'https://twitter.com/Box8_in',
                handle: 'Box8_in'
            },
            insta: {
                url: 'https://www.instagram.com/box8_official/'
            },
            website: {
                url: 'https://box8.in'
            }
        },
        blog: 'https://blog.box8.in'
    },

    sentryDsn: 'https://5f0a610e12794467a5ea2cc1f9159442@sentry.io/1362239'
};

export const environmentFactory = () => environment;
